import React, { FunctionComponent } from 'react';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import ControlledNumberField2 from './ControlledNumberField2';
import { useFieldStyles } from './FieldStyles';
import clsx from 'clsx';
import { PriceField2Props } from './PriceField2';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        labelContainer2: {
            marginLeft: 0,
            color: 'red'
        }
    })
);

export const ControlledPriceField2: FunctionComponent<PriceField2Props> = props => {
    const classes = useFieldStyles();
    const classes2 = useStyles();

    return (
        <ControlledNumberField2
            {...props}
            labelClassName={classes2.labelContainer2}
            startIcon={<Typography className={classes.adornmentText}>$</Typography>}
            className={clsx(classes.inputTextLeft, props.className)}
        />
    );
};

export default ControlledPriceField2;
